/**
 * Builds stable data-webid values for Magnet QA/automation.
 * Format: magnet.{area}.{element} (kebab-case segments)
 *
 * @param {...string} parts - Area and element segments (underscores become hyphens)
 * @returns {string}
 */
export const webId = (...parts) =>
  ['magnet', ...parts]
    .filter(Boolean)
    .join('.')
    .replace(/_/g, '-')

export default webId
